module.exports = __webpack_public_path__ + "static/media/logo.e58d6d40.png";